import Input from '@cred/react-editors/input'
import withFieldChangeEvent from '@cred/react-analytics/hoc/withFieldChangeEvent'

const InputWithAnalytics = withFieldChangeEvent(Input)

export default InputWithAnalytics
